<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ForgotPassword from '../../auth/components/ForgotPassword.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <ForgotPassword />
</template>